import { Paper } from '@mui/material'
import React, { useCallback, useState } from 'react'
import {useDropzone} from 'react-dropzone'

const AddImages = () => {
    const [files, setFiles] = useState([]);
    const onDrop = useCallback((acceptedFiles) =>{
        setFiles(acceptedFiles);
        //console.log(acceptedFiles);
    },[])
    const {getRootProps, getInputProps, isDragActive} = useDropzone({
        onDrop,
        accept: {'image/*': []}
    })


    return (
        <Paper
            sx={{
                cursor: 'pointer',
                bgcolor: '#fafafa',
                color: '#bdbdbd',
                border: '1px dashed #ccc',
                '&:hover': {border: '1px solid #ccc'}
            }}>
                <div style={{padding: '16px'}} {...getRootProps()}>
                    <input {...getInputProps()}/>
                    {isDragActive?(
                        <p style={{color:'green'}}>Suelte las imagenes aquí</p>
                    ) : (<p>Arrastre y suelte las imágenes aquí, o haga click para seleccionarlas.</p>)}
                    <em>(Imágenes aceptadas: jpeg, png, jpg)</em>
                </div>
            
        </Paper>
    )
}

export default AddImages